import { createReducer } from 'reduxsauce';
import { cloneDeep, isEqual, findIndex, filter } from 'lodash';

import { ShiftsTypes } from '../actions/shifts.actions';

const initialState = {
  status: [],
  allShifts: [],
  userShifts: [],
  successUserShifts: null,
  shiftDetails: null,
  successSubmitShift: null,
};

const getAllShiftsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-all-shifts');
  return { ...state, status };
};
const getAllShiftsSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-all-shifts', a));

  return { ...state, allShifts: action.response, status };
};
const getAllShiftsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-all-shifts', a));
  return { ...state, status };
};

const getUserShiftsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-user-shifts');

  return { ...state, status };
};
const getUserShiftsSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-user-shifts', a));

  return {
    ...state,
    userShifts: action.response,
    successUserShifts: true,
    status,
  };
};
const getUserShiftsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-user-shifts', a));

  return { ...state, status };
};

const getShiftRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-shift-details');

  return { ...state, status };
};
const getShiftSuccess = (state, action) => {
  const shiftDetails = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-details', a));

  return {
    ...state,
    shiftDetails,
    status,
  };
};
const getShiftFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-details', a));

  return { ...state, status };
};

const createShiftequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-create-shift');

  return { ...state, status };
};
const createShiftSuccess = (state, action) => {
  const allShifts = cloneDeep(state.allShifts);
  if (action.response) allShifts.push(...action.response);

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-shift', a));

  return {
    ...state,
    allShifts,
    successSubmitShift: true,
    status,
  };
};
const createShiftFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-shift', a));

  return { ...state, status };
};

const updateShiftRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-update-shift');

  return { ...state, status };
};
const updateShiftSuccess = (state, action) => {
  const shiftEdited = action.response;

  const allShifts = cloneDeep(state.allShifts);
  const idx = findIndex(allShifts, (e) => e.id === shiftEdited.id);
  if (idx > -1) allShifts[idx] = shiftEdited;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-shift', a));

  return {
    ...state,
    allShifts,
    shiftDetails: null,
    successSubmitShift: true,
    status,
  };
};
const updateShiftFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-update-shift', a));

  return { ...state, status };
};

const deleteShiftRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-delete-shift-${action.shiftId}`);

  return { ...state, status };
};
const deleteShiftSuccess = (state, action) => {
  let allShifts = cloneDeep(state.allShifts);
  allShifts = filter(allShifts, (e) => !isEqual(e.id, Number(action.shiftId)));

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-shift-${action.shiftId}`, a));

  return { ...state, allShifts, status };
};
const deleteShiftFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-shift-${action.shiftId}`, a));

  return { ...state, status };
};

const clearSuccessGetUserShiftsRequest = (state) => ({
  ...state,
  successUserShifts: null,
});

const clearSuccessSubmitShiftRequest = (state) => ({
  ...state,
  shiftDetails: null,
  successSubmitShift: null,
});

const clearShiftsRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [ShiftsTypes.GET_ALL_SHIFTS_REQUEST]: getAllShiftsRequest,
  [ShiftsTypes.GET_ALL_SHIFTS_SUCCESS]: getAllShiftsSuccess,
  [ShiftsTypes.GET_ALL_SHIFTS_FAILURE]: getAllShiftsFailure,

  [ShiftsTypes.GET_USER_SHIFTS_REQUEST]: getUserShiftsRequest,
  [ShiftsTypes.GET_USER_SHIFTS_SUCCESS]: getUserShiftsSuccess,
  [ShiftsTypes.GET_USER_SHIFTS_FAILURE]: getUserShiftsFailure,

  [ShiftsTypes.GET_SHIFT_REQUEST]: getShiftRequest,
  [ShiftsTypes.GET_SHIFT_SUCCESS]: getShiftSuccess,
  [ShiftsTypes.GET_SHIFT_FAILURE]: getShiftFailure,

  [ShiftsTypes.CREATE_SHIFT_REQUEST]: createShiftequest,
  [ShiftsTypes.CREATE_SHIFT_SUCCESS]: createShiftSuccess,
  [ShiftsTypes.CREATE_SHIFT_FAILURE]: createShiftFailure,

  [ShiftsTypes.UPDATE_SHIFT_REQUEST]: updateShiftRequest,
  [ShiftsTypes.UPDATE_SHIFT_SUCCESS]: updateShiftSuccess,
  [ShiftsTypes.UPDATE_SHIFT_FAILURE]: updateShiftFailure,

  [ShiftsTypes.DELETE_SHIFT_REQUEST]: deleteShiftRequest,
  [ShiftsTypes.DELETE_SHIFT_SUCCESS]: deleteShiftSuccess,
  [ShiftsTypes.DELETE_SHIFT_FAILURE]: deleteShiftFailure,

  [ShiftsTypes.CLEAR_SUCCESS_GET_USER_SHIFTS_REQUEST]: clearSuccessGetUserShiftsRequest,

  [ShiftsTypes.CLEAR_SUCCESS_SUBMIT_SHIFT_REQUEST]: clearSuccessSubmitShiftRequest,

  [ShiftsTypes.CLEAR_SHIFTS_REQUEST]: clearShiftsRequest,
});
